<section class="dv-hero" id="home">
  <div class="hero-media" aria-hidden="true">
    <div class="hero-horizon"></div>
    <!-- The official logo, faded (never cropped or covered): replaces the old outlined wordmark. -->
    <img class="hero-logo" src="assets/images/brand/logo-white.svg" alt="" width="199" height="64" />
    <div class="hero-road"><span></span><span></span><span></span></div>
    <div class="hero-car-shadow"></div>
    <div class="hero-camera">
      <!-- The car picture DrivOn supplied, used as is (tools/brand-assets/export-car.mjs only scales it down). -->
      <img class="hero-img" src="assets/images/background/hero-car.webp" alt="" width="2400" height="792" decoding="async" fetchpriority="high" />
    </div>
  </div>
  <div class="hero-scrim" aria-hidden="true"></div>
  <div class="hero-streaks dv-motion-only" aria-hidden="true">
    <i></i><i></i><i></i><i></i><i></i><i></i>
  </div>
  <div class="container hero-text-wrap">
    <div class="hero-headline">
      <h1 class="hero-line" [appSplitText]="'home.welcome.text-1' | translate" splitMode="intro" splitDelay="0.15"></h1>
      <p class="hero-line hero-line--accent" [appSplitText]="'home.welcome.text-2' | translate" splitMode="intro" splitDelay="0.3"></p>
      <span class="hero-sheen" aria-hidden="true"></span>
    </div>
    <div class="hero-cta-wrap">
      <a class="dv-pill hero-primary cta-sheen" appMagnetic [href]="motion.sectionHref('contact')" (click)="scrollToContact($event)">
        <span class="magnetic-label">{{ 'home.welcome.contact-btn' | translate }}</span><span class="hero-button-arrow" aria-hidden="true"><span class="brand-icon brand-icon--arrow"></span></span>
      </a>
      <a class="hero-secondary" [routerLink]="link('/quiz/v2/abc')">{{ 'home.design.practice' | translate }}<span class="brand-icon brand-icon--arrow" aria-hidden="true"></span></a>
    </div>
  </div>
  <a class="hero-cue" [href]="motion.sectionHref('about')" (click)="scrollToAbout($event)">
    <span class="hero-cue-line" aria-hidden="true"></span><span>{{ 'home.design.scroll' | translate }}</span><span aria-hidden="true">↓</span>
  </a>
</section>
